import{j as e}from"./chunk-GEPA7FLG.js";e();import{gql as r}from"@apollo/client";var i=r`
  query stakingGroups($address: String!, $filterArgs: GenericFarmFilterArgs) {
    stakingGroups(address: $address, filterArgs: $filterArgs, vmQuery: false) {
      farmingToken {
        details {
          identifier
          decimals
          name
          balance
          ticker
          assets {
            svgUrl
            pngUrl
          }
        }
        canBeLocked
        canBeUnlocked
      }
      rewardToken {
        details {
          identifier
          decimals
          name
          balance
          ticker
          assets {
            svgUrl
            pngUrl
          }
        }
        canBeLocked
        canBeUnlocked
      }
      totalValueLockedUsd
      apr {
        lowestApr
        highestApr
        type
      }
      myStakedAmount
      myEarnedAmount
      creationDate
      expiryDate
      groupId
      isCompoundAllowed
    }
  }
`;export{i as a};
//# sourceMappingURL=chunk-CXZNAUBQ.js.map
